export interface IFile {
	file_name?: string;
	file_data?: string;
	contact_id?: number;
	is_public?: boolean;
	file_association?: string;
}
